/* 🤖 this file was generated by script */
export const wiconCornerDownLeft = {
  name: 'corner_down_left',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 4v1.4c0 3.36 0 5.04-.65 6.32a6 6 0 01-2.63 2.63c-1.28.65-2.96.65-6.32.65H4m0 0l5-5m-5 5l5 5"/></svg>`,
};
